import { render, staticRenderFns } from "./attribDroit.vue?vue&type=template&id=b7f2f1c2"
import script from "./attribDroit.vue?vue&type=script&lang=js"
export * from "./attribDroit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports